import { IconContext } from 'react-icons';
import {
  MdAdd,
  MdAreaChart,
  MdBarChart,
  MdCalendarMonth,
  MdFormatListBulleted,
  MdModeEditOutline,
} from 'react-icons/md';
import React from 'react';


export default function TypeNavbar({
                                     origType,
                                     toggleDays,
                                     daysVisible,
                                     toggleBarChart,
                                     barVisible,
                                     toggleAreaGraph,
                                     areaVisible,
                                     toggleEditType,
                                     editTypeVisible,
                                     toggleReadings,
                                     readingsVisible,
                                     toggleVisibility,
                                     formVisible,
                                   }) {

  return (

    <div style={{ width: 800, textAlign: 'center' }}>

      <div style={{
        display: 'inline-block',
        fontWeight: 'bolder',
        fontSize: 30,
        height: 40,
        backgroundColor: 'white',
        paddingRight: 10,
        paddingLeft: 50,
      }}>{origType.name}</div>


      <div style={{ display: 'inline-block', width: 40, height: 40, backgroundColor: 'white', float: 'left' }}>
        <button className="add" onClick={toggleDays}><IconContext.Provider
          value={{ size: '30', color: daysVisible ? 'red' : 'blue' }}><MdCalendarMonth /></IconContext.Provider>
        </button>
      </div>


      <div style={{ display: 'inline-block', width: 40, height: 40, backgroundColor: 'white', float: 'left' }}>
        <button className="add" onClick={toggleBarChart}><IconContext.Provider
          value={{ size: '30', color: barVisible ? 'red' : 'blue' }}><MdBarChart /></IconContext.Provider></button>
      </div>

      <div style={{ display: 'inline-block', width: 40, height: 40, backgroundColor: 'white', float: 'left' }}>
        <button className="add" onClick={toggleAreaGraph} title={origType.name + ' Range Graph'}><IconContext.Provider
          value={{ size: '30', color: areaVisible ? 'red' : 'blue' }}><MdAreaChart /></IconContext.Provider></button>
      </div>


      <div style={{ display: 'inline-block', width: 40, height: 40, backgroundColor: 'white', float: 'right' }}>
        <button className="add" onClick={toggleEditType} title={'Edit ' + origType.name}><IconContext.Provider
          value={{ size: '30', color: editTypeVisible ? 'red' : 'blue' }}><MdModeEditOutline /></IconContext.Provider>
        </button>
      </div>

      <div style={{ display: 'inline-block', width: 40, height: 40, backgroundColor: 'white', float: 'right' }}>
        <button className="add" onClick={toggleReadings}><IconContext.Provider
          value={{
            size: '30',
            color: readingsVisible ? 'red' : 'blue',
          }}><MdFormatListBulleted /></IconContext.Provider>
        </button>
      </div>

      <div style={{ display: 'inline-block', width: 40, height: 40, backgroundColor: 'white', float: 'right' }}>
        <button className="add" onClick={toggleVisibility}><IconContext.Provider
          value={{ size: '30', color: formVisible ? 'red' : 'blue' }}><MdAdd /></IconContext.Provider></button>
      </div>
    </div>
  );

}